// libraries
import React, { useEffect, useState } from 'react'
import clsx from 'clsx'

// svg
import { Check, Loading } from '/react4xp/components/Svg/Ux/Ux'

interface SubmitProps {
    id?: string
    label?: string
    disabled?: boolean
    className?: string
    successMessage?: string
    errorMessage?: string
}

export default function Submit({
    id,
    label,
    disabled,
    className,
    successMessage,
    errorMessage
}: SubmitProps) {

    const [isSending, setIsSending] = useState(false)
    const [isSent, setIsSent] = useState(false)
    const [error, setError] = useState(false)

    // display the loading / spinner
    useEffect(() => {
        const isSending = () => {
            setIsSending(true)
            setError(false)
            setIsSent(false)
		}

		document.addEventListener('formSending', isSending)

		return () => {
			document.removeEventListener('formSending', isSending)
		}
    }, [])

    // hide the loading / spinner and display the sent message
    useEffect(() => {
        const isSent = () => {
            setIsSending(false)
            setIsSent(true)
		}

		document.addEventListener('formSent', isSent)

		return () => {
			document.removeEventListener('formSent', isSent)
		}
    }, [])

    // clear everything after 4 seconds (defined inside Form.tsx)
    useEffect(() => {
        const clearIsSent = () => {
            setIsSending(false)
            setIsSent(false)
            setError(false)
		}

		document.addEventListener('clearFormSent', clearIsSent)

		return () => {
			document.removeEventListener('clearFormSent', clearIsSent)
		}
    }, [])

    // hide the loading / spinner and display the error message
    useEffect(() => {
        const hasErrors = () => {
            setIsSending(false)
            setError(true)
		}

		document.addEventListener('formError', hasErrors)

		return () => {
			document.removeEventListener('formError', hasErrors)
		}
    }, [])

    // clear the is sending state
    useEffect(() => {
        const submitReset = () => {
            setIsSending(false)
		}

		document.addEventListener('formResetSubmit', submitReset)

		return () => {
			document.removeEventListener('formResetSubmit', submitReset)
		}
    }, [])

    return (
        <div className={clsx(
            'submit-wrapper',
            className
        )}>

            <button
                id={id || null}
                type='submit'
                className={clsx(
                    'submit-button labels-xl-medium',
                    isSending && 'submit-button--sending',
                    isSent && 'submit-button--sent'
                )}
                disabled={disabled || false}
            >
                {isSent ? (
                    <>

                        <span className='submit-button__label'>
                            Submitted
                        </span>

                        <Check />

                    </>
                ) : (
                    <>

                        <span className='submit-button__label'>
                            {label || 'Submit'}
                        </span>

                        { isSending && (
                            <span className='loading'>
                                <Loading />
                            </span>
                        )}

                    </>
                )}
                
            </button>

            {isSent && (
                <p className='text-md sent-message'>
                    {successMessage || 'Your message has been submitted successfully.'}
                </p>
            )}

            {error && (
                <p className='text-md error-message'>
                    {errorMessage || 'Something went wrong. Please try again.'}
                </p>
            )}

        </div>
    )
}